import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.warn("Supabase env vars are missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.");
}

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "");

const PRODUCT_BUCKET = "product-assets";

export async function getProductImageUrl(path) {
  if (!path) return null;

  // If a full URL is stored, return as-is.
  if (/^https?:\/\//i.test(path)) return path;

  try {
    // Public bucket path
    const { data } = supabase.storage.from(PRODUCT_BUCKET).getPublicUrl(path);
    if (data?.publicUrl) return data.publicUrl;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("Public URL fetch failed", err?.message || err);
  }

  try {
    // Private bucket fallback: signed URL for 1 hour
    const signed = await supabase.storage.from(PRODUCT_BUCKET).createSignedUrl(path, 3600);
    if (signed?.data?.signedUrl) return signed.data.signedUrl;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("Signed URL fetch failed", err?.message || err);
  }

  return null;
}
